/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ForbiddenResponse,
  Health,
  PlatformPendency,
  ServiceUnavailableResponse,
  UnauthorizedResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetHealthUrl = () => {




  return `/healthz`
}

/**
 * Sonda de saude usada pelo balanceador e pelo `docker compose`. Nao exige
 * sessao e nao devolve dado de pessoa.
 * @summary Verifica se o processo e suas dependencias respondem
 */
export const getHealth = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Health> => {

  return apiFetch<Health>(getGetHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHealthQueryKey = () => {
    return [
    `/healthz`
    ] as const;
    }


export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = ServiceUnavailableResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = ServiceUnavailableResponse


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ServiceUnavailableResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ServiceUnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ServiceUnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Verifica se o processo e suas dependencias respondem
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ServiceUnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPlatformPendenciesUrl = () => {




  return `/v1/platform/pendencies`
}

/**
 * Devolve o conteudo provisorio ainda ativo: preco de um centavo, texto
 * juridico `0.0.0-placeholder`, valor por aula nao ratificado, politicas de
 * material, anexo, retencao e lembrete, escalas de nota e tipos de
 * avaliacao, e o texto nao aprovado dos modelos de e-mail.
 *
 * **Exclusiva de Super Admin**, e a exclusividade e o desenho e nao uma
 * permissao herdada. A lista nomeia o que a plataforma faz de errado
 * enquanto a decisao nao chega — que aluno e professor nao tem como
 * corrigir e nao deveriam ter de ler.
 *
 * Ate 16 de agosto de 2026 esta informacao nao precisava existir: conteudo
 * provisorio com `BlocksBoot` RECUSAVA a subida em producao, e as
 * operacoes afetadas respondiam 503. As duas guardas foram trocadas por
 * esta leitura, a pedido do cliente, para que a plataforma pudesse ser
 * exercitada inteira antes de existir aluno real. A recusa era um portao;
 * isto e um aviso, e a diferenca e que o aviso precisa ser LIDO.
 *
 * Lista vazia significa que nada esta provisorio — e a resposta que se
 * espera no dia em que as decisoes forem todas fechadas.
 * @summary Lista as decisoes de negocio que a plataforma ainda carrega em aberto
 */
export const listPlatformPendencies = async ( options?: Parameters<typeof apiFetch>[1]): Promise<PlatformPendency[]> => {

  return apiFetch<PlatformPendency[]>(getListPlatformPendenciesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformPendenciesQueryKey = () => {
    return [
    `/v1/platform/pendencies`
    ] as const;
    }


export const getListPlatformPendenciesQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformPendencies>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformPendencies>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformPendenciesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformPendencies>>> = ({ signal }) => listPlatformPendencies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformPendencies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlatformPendenciesQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformPendencies>>>
export type ListPlatformPendenciesQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListPlatformPendencies<TData = Awaited<ReturnType<typeof listPlatformPendencies>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformPendencies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformPendencies>>,
          TError,
          Awaited<ReturnType<typeof listPlatformPendencies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformPendencies<TData = Awaited<ReturnType<typeof listPlatformPendencies>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformPendencies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformPendencies>>,
          TError,
          Awaited<ReturnType<typeof listPlatformPendencies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformPendencies<TData = Awaited<ReturnType<typeof listPlatformPendencies>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformPendencies>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as decisoes de negocio que a plataforma ainda carrega em aberto
 */

export function useListPlatformPendencies<TData = Awaited<ReturnType<typeof listPlatformPendencies>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformPendencies>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlatformPendenciesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






